import { IFormField} from "../web-form.objects"
import { JsonItem, PickListItem } from "../../../entities/pick-list/pick-list.entities";
import _ from "lodash";
import { DoArraysOverlap } from "../../../scripts/array-functions";

export class HiddenInputOptions {
    parentInputId: string; // Form field being referenced
    parentInputType: ParentInputType 
    showParentValueArray?: string[]; // if parent input matches any of these values, show the field
    hiddenInput: IFormField; // Input being shown/hidden
    isNested?: boolean; // is part of a nested input
    showInRange?: NumberRange;

    constructor(parentInputId: string, parentInputType: ParentInputType, showParentValueArray: any[], hiddenInput: IFormField, isNested: boolean = false) {
        this.parentInputId = parentInputId;
        this.parentInputType = parentInputType;
        this.showParentValueArray = showParentValueArray;
        this.hiddenInput = hiddenInput;
        this.isNested = isNested;
    }
}

export class NumberRange {
    minVal?: number;
    maxVal?: number;

    constructor(minVal: number = undefined, maxVal: number = undefined) {
        this.minVal = minVal;
        this.maxVal = maxVal;
    }
}

export enum ParentInputType {
    DropdownSingle = 1, 
    DropdownMulti = 2,
    YesNo = 3,
    Number = 4
}

export class HiddenInputField implements IFormField {
    inputField: IFormField;

    fieldId: string; 
    displayName: string; 
    description: string;
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    initialVal: any;

    options: HiddenInputOptions;

    isHidden: boolean = true;

    constructor(options: HiddenInputOptions) {
        this.inputField = options.hiddenInput;

        this.fieldId = this.inputField.fieldId;
        this.displayName = this.inputField.displayName;
        this.description = this.inputField.description;
        this.isRequired = this.inputField.isRequired;
        this.propertyName = this.inputField.propertyName;

        this.options = options;

        this.defaultVal = this.inputField.defaultVal;
        this.initialVal = this.inputField.initialVal;

        this.isHidden = true;
    }

    generateHtml(): string {
        // logic for handling nested form table (table/gallery)
        if (this.options.isNested) {
            if (this.fieldId.startsWith("edit-")) {
                if (!this.options.parentInputId.startsWith("edit-")) {
                    this.options.parentInputId = `edit-${this.options.parentInputId}`;
                }
                if (!this.inputField.fieldId.startsWith("edit-")) {
                    this.inputField.fieldId = `edit-${this.inputField.fieldId}`
                }
            }
        }

        let html = `
            <div id="${this.fieldId}-hidden-container" class="d-none">
                ${this.inputField.generateHtml()}
            </div>
        `;

        return html;
    }

    initialize() {
        this.inputField.initialize();

        // show/hide
        $(`#${this.options.parentInputId}`).on("form-field-change", () => {
            let shouldShow = this.shouldShowHiddenInput();
            this.showHiddenInput(shouldShow);
        })

        $(`#${this.options.parentInputId}-hidden-container`).on("form-field-hidden", () => {
            // force hide if the parent container gets hidden
            this.showHiddenInput(false);
        })
    }

    prepopulate(items: any[]): void {
        this.inputField.prepopulate(items);
    }

    updateItem(item: any): any {
        return this.inputField.updateItem(item);
    }

    setOptions(pickLists: JsonItem[]) {
        this.inputField.setOptions(pickLists);
    }

    getValue(): any {
        return this.inputField.getValue();
    }

    setValue(formData: any) {
        this.inputField.setValue(formData);
    }

    checkValid(): boolean {
        if (this.isHidden) {
            return true;
        }
        else {
            return this.inputField.checkValid();
        }
    }

    checkChanged(): boolean {
        return this.inputField.checkChanged();
    }

    displayValid(isValid: boolean) {
        this.inputField.displayValid(isValid);
    }

    resetValidDisplay() {
        this.inputField.resetValidDisplay();
    }

    compareItems(item1: any, item2: any): boolean {
        return this.inputField.compareItems(item1, item2);
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        return this.inputField.generateChangeHtml(newItem, prevItem);
    }

    private showHiddenInput(shouldShow: boolean = true) {
        if (shouldShow) {
            $(`#${this.fieldId}-hidden-container`).removeClass("d-none");         
        }
        else {
            this.resetInput();
            $(`#${this.fieldId}-hidden-container`).addClass("d-none");
            $(`#${this.fieldId}-hidden-container`).trigger("form-field-hidden");
        }
        this.isHidden = !shouldShow;
    }

    private shouldShowHiddenInput(): boolean {
        if (this.options.parentInputType == ParentInputType.DropdownSingle) {
            let val = <string>$(`#${this.options.parentInputId}`).val();
            if (this.options.showParentValueArray.includes(val)) {
                return true;
            }
        }
        if (this.options.parentInputType == ParentInputType.DropdownMulti) {
            let valArr = <string[]>$(`#${this.options.parentInputId}`).val();
            let isOverlap = DoArraysOverlap(valArr, this.options.showParentValueArray);
            if (isOverlap) return true;
        }
        if (this.options.parentInputType == ParentInputType.YesNo) {
            let val = <string>$(`#${this.options.parentInputId}`).val();
            if (this.options.showParentValueArray.includes(val)) {
                return true;
            }
        }
        if (this.options.parentInputType == ParentInputType.Number && this.options.showInRange) {
            let val = <number>$(`#${this.options.parentInputId}`).val();
            if (this.options.showInRange?.minVal != undefined) {
                if (val < this.options.showInRange?.minVal) {
                    return false;
                }
            }
            if (this.options.showInRange?.maxVal != undefined) {
                if (val > this.options.showInRange?.maxVal) {
                    return false;
                }
            }
            return true;
        }

        return false;
    }

    private resetInput(): void {
        this.inputField.prepopulate([]);
    }
}

